var _rect, _line, _mask, _path, _mask2, _path2, _mask3, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 114,
    viewBox: "0 0 150 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 148,
    height: 132,
    rx: 8,
    stroke: "#2369CC",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 58.7071,
    y1: 15.7071,
    x2: 34.715,
    y2: 39.6992,
    stroke: "#2369CC",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_13_99",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 39V114C34 116.209 35.7909 118 38 118H112C114.209 118 116 116.209 116 114V19C116 16.7909 114.209 15 112 15H58V35C58 37.2091 56.2091 39 54 39H34Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 39V38H33V39H34ZM58 15V14H57V15H58ZM35 114V39H33V114H35ZM38 117C36.3431 117 35 115.657 35 114H33C33 116.761 35.2386 119 38 119V117ZM112 117H38V119H112V117ZM115 114C115 115.657 113.657 117 112 117V119C114.761 119 117 116.761 117 114H115ZM115 19V114H117V19H115ZM112 16C113.657 16 115 17.3431 115 19H117C117 16.2386 114.761 14 112 14V16ZM58 16H112V14H58V16ZM57 15V35H59V15H57ZM57 35C57 36.6569 55.6569 38 54 38V40C56.7614 40 59 37.7614 59 35H57ZM54 38H34V40H54V38Z",
    fill: "#2369CC",
    mask: "url(#path-3-inside-1_13_99)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_13_99",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 39V114C35 116.209 36.7909 118 39 118H113C115.209 118 117 116.209 117 114V19C117 16.7909 115.209 15 113 15H59V35C59 37.2091 57.2091 39 55 39H35Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 39V38H34V39H35ZM59 15V14H58V15H59ZM36 114V39H34V114H36ZM39 117C37.3431 117 36 115.657 36 114H34C34 116.761 36.2386 119 39 119V117ZM113 117H39V119H113V117ZM116 114C116 115.657 114.657 117 113 117V119C115.761 119 118 116.761 118 114H116ZM116 19V114H118V19H116ZM113 16C114.657 16 116 17.3431 116 19H118C118 16.2386 115.761 14 113 14V16ZM59 16H113V14H59V16ZM58 15V35H60V15H58ZM58 35C58 36.6569 56.6569 38 55 38V40C57.7614 40 60 37.7614 60 35H58ZM55 38H35V40H55V38Z",
    fill: "#2369CC",
    mask: "url(#path-5-inside-2_13_99)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-3_13_99",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 40V115C35 117.209 36.7909 119 39 119H113C115.209 119 117 117.209 117 115V20C117 17.7909 115.209 16 113 16H59V36C59 38.2091 57.2091 40 55 40H35Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 40V39H34V40H35ZM59 16V15H58V16H59ZM36 115V40H34V115H36ZM39 118C37.3431 118 36 116.657 36 115H34C34 117.761 36.2386 120 39 120V118ZM113 118H39V120H113V118ZM116 115C116 116.657 114.657 118 113 118V120C115.761 120 118 117.761 118 115H116ZM116 20V115H118V20H116ZM113 17C114.657 17 116 18.3431 116 20H118C118 17.2386 115.761 15 113 15V17ZM59 17H113V15H59V17ZM58 16V36H60V16H58ZM58 36C58 37.6569 56.6569 39 55 39V41C57.7614 41 60 38.7614 60 36H58ZM55 39H35V41H55V39Z",
    fill: "#2369CC",
    mask: "url(#path-7-inside-3_13_99)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 47,
    width: 28,
    height: 6,
    rx: 1,
    stroke: "#2369CC",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 60,
    width: 28,
    height: 6,
    rx: 1,
    stroke: "#2369CC",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 73,
    width: 28,
    height: 6,
    rx: 1,
    stroke: "#2369CC",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 73,
    width: 28,
    height: 6,
    rx: 1,
    stroke: "#2369CC",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 99,
    width: 64,
    height: 6,
    rx: 1,
    stroke: "#2369CC",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 86,
    width: 64,
    height: 6,
    rx: 1,
    stroke: "#2369CC",
    strokeWidth: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 47,
    width: 28,
    height: 18,
    rx: 1,
    stroke: "#2369CC",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1697 29.7273V37H72.6321V29.7273H74.1697ZM76.9192 33.8466V37H75.4064V31.5455H76.8482V32.5078H76.9121C77.0328 32.1906 77.2353 31.9396 77.5194 31.755C77.8034 31.5679 78.1479 31.4744 78.5527 31.4744C78.9315 31.4744 79.2618 31.5573 79.5435 31.723C79.8252 31.8887 80.0442 32.1255 80.2005 32.4332C80.3567 32.7386 80.4348 33.1032 80.4348 33.527V37H78.9221V33.7969C78.9244 33.4631 78.8392 33.2027 78.6664 33.0156C78.4935 32.8262 78.2556 32.7315 77.9526 32.7315C77.749 32.7315 77.5691 32.7753 77.4128 32.8629C77.2589 32.9505 77.1382 33.0784 77.0506 33.2464C76.9654 33.4122 76.9216 33.6122 76.9192 33.8466ZM86.517 31.5455L84.6101 37H82.9055L80.9986 31.5455H82.5966L83.7294 35.4482H83.7862L84.9155 31.5455H86.517ZM89.5799 37.1065C89.0283 37.1065 88.5513 36.9893 88.1488 36.755C87.7487 36.5182 87.4397 36.1892 87.2219 35.7678C87.0041 35.344 86.8952 34.8527 86.8952 34.294C86.8952 33.7306 87.0041 33.2382 87.2219 32.8168C87.4397 32.393 87.7487 32.0639 88.1488 31.8295C88.5513 31.5928 89.0283 31.4744 89.5799 31.4744C90.1315 31.4744 90.6074 31.5928 91.0075 31.8295C91.4099 32.0639 91.7201 32.393 91.9379 32.8168C92.1557 33.2382 92.2646 33.7306 92.2646 34.294C92.2646 34.8527 92.1557 35.344 91.9379 35.7678C91.7201 36.1892 91.4099 36.5182 91.0075 36.755C90.6074 36.9893 90.1315 37.1065 89.5799 37.1065ZM89.587 35.9347C89.8379 35.9347 90.0475 35.8636 90.2156 35.7216C90.3836 35.5772 90.5103 35.3807 90.5955 35.1321C90.6831 34.8835 90.7269 34.6006 90.7269 34.2834C90.7269 33.9661 90.6831 33.6832 90.5955 33.4347C90.5103 33.1861 90.3836 32.9896 90.2156 32.8452C90.0475 32.7008 89.8379 32.6286 89.587 32.6286C89.3337 32.6286 89.1206 32.7008 88.9478 32.8452C88.7773 32.9896 88.6483 33.1861 88.5607 33.4347C88.4755 33.6832 88.4329 33.9661 88.4329 34.2834C88.4329 34.6006 88.4755 34.8835 88.5607 35.1321C88.6483 35.3807 88.7773 35.5772 88.9478 35.7216C89.1206 35.8636 89.3337 35.9347 89.587 35.9347ZM93.2482 37V31.5455H94.761V37H93.2482ZM94.0082 30.8423C93.7833 30.8423 93.5903 30.7678 93.4293 30.6186C93.2707 30.4671 93.1914 30.286 93.1914 30.0753C93.1914 29.867 93.2707 29.6882 93.4293 29.5391C93.5903 29.3875 93.7833 29.3118 94.0082 29.3118C94.2331 29.3118 94.4248 29.3875 94.5835 29.5391C94.7444 29.6882 94.8249 29.867 94.8249 30.0753C94.8249 30.286 94.7444 30.4671 94.5835 30.6186C94.4248 30.7678 94.2331 30.8423 94.0082 30.8423ZM98.4373 37.1065C97.8786 37.1065 97.398 36.9882 96.9956 36.7514C96.5955 36.5123 96.2877 36.1809 96.0723 35.7571C95.8592 35.3333 95.7527 34.8456 95.7527 34.294C95.7527 33.7353 95.8604 33.2453 96.0758 32.8239C96.2936 32.4001 96.6026 32.0698 97.0027 31.8331C97.4028 31.594 97.8786 31.4744 98.4302 31.4744C98.9061 31.4744 99.3227 31.5608 99.6802 31.7337C100.038 31.9065 100.321 32.1491 100.529 32.4616C100.737 32.7741 100.852 33.1411 100.873 33.5625H99.4458C99.4056 33.2902 99.2991 33.0713 99.1262 32.9055C98.9558 32.7375 98.7321 32.6534 98.4551 32.6534C98.2207 32.6534 98.0159 32.7173 97.8407 32.8452C97.6679 32.9706 97.533 33.1541 97.4359 33.3956C97.3388 33.6371 97.2903 33.9295 97.2903 34.2727C97.2903 34.6207 97.3377 34.9167 97.4324 35.1605C97.5294 35.4044 97.6655 35.5902 97.8407 35.718C98.0159 35.8459 98.2207 35.9098 98.4551 35.9098C98.6279 35.9098 98.783 35.8743 98.9203 35.8033C99.06 35.7322 99.1748 35.6293 99.2647 35.4943C99.3571 35.357 99.4174 35.1925 99.4458 35.0007H100.873C100.85 35.4174 100.736 35.7843 100.532 36.1016C100.331 36.4164 100.053 36.6626 99.698 36.8402C99.3429 37.0178 98.9226 37.1065 98.4373 37.1065ZM104.328 37.1065C103.767 37.1065 103.284 36.9929 102.879 36.7656C102.476 36.536 102.166 36.2116 101.949 35.7926C101.731 35.3712 101.622 34.8729 101.622 34.2976C101.622 33.7365 101.731 33.2441 101.949 32.8203C102.166 32.3965 102.473 32.0663 102.868 31.8295C103.266 31.5928 103.732 31.4744 104.267 31.4744C104.627 31.4744 104.962 31.5324 105.272 31.6484C105.585 31.7621 105.857 31.9337 106.089 32.1634C106.324 32.393 106.506 32.6818 106.636 33.0298C106.766 33.3755 106.831 33.7803 106.831 34.2443V34.6598H102.225V33.7223H105.407C105.407 33.5045 105.36 33.3116 105.265 33.1435C105.171 32.9754 105.039 32.844 104.871 32.7493C104.705 32.6522 104.512 32.6037 104.292 32.6037C104.063 32.6037 103.859 32.657 103.681 32.7635C103.506 32.8677 103.369 33.0085 103.27 33.1861C103.17 33.3613 103.119 33.5566 103.117 33.772V34.6634C103.117 34.9332 103.167 35.1664 103.266 35.3629C103.368 35.5594 103.511 35.7109 103.696 35.8175C103.88 35.924 104.099 35.9773 104.353 35.9773C104.521 35.9773 104.675 35.9536 104.814 35.9062C104.954 35.8589 105.074 35.7879 105.173 35.6932C105.272 35.5985 105.348 35.4825 105.4 35.3452L106.799 35.4375C106.728 35.7737 106.583 36.0672 106.363 36.3182C106.145 36.5668 105.863 36.7609 105.517 36.9006C105.174 37.0379 104.778 37.1065 104.328 37.1065Z",
    fill: "#2369CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/invoice-icon.57d30f01c6bb81a5404dfc94fbfc6560.svg";
export { ForwardRef as ReactComponent };